import React from "react";

const Divider = () => {
  return (
    <div className="w-full h-32 relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-black"
        style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 25%, 0 100%)'
        }}
      />
      <div 
        className="absolute inset-0 bg-white"
        style={{
          clipPath: 'polygon(0 100%, 100% 25%, 100% 100%, 0 100%)'
        }}
      />
    </div>
  );
};

export default Divider; 